import React from 'react'
import ModuleCard from './ModuleCard'

export default React.memo(function AIModules({ modules }) {
  return (
    <div className='grid gap-4 grid-cols-3 pt-4'>
      {
        modules.map(module => (
          <ModuleCard module={module} key={module.name}></ModuleCard>
        ))
      }
    </div>
  )
})
